import 'glightbox/dist/css/glightbox.min.css'
import GLightbox from 'glightbox'

const glighboxVideoBtnsSelectors = [
	'[data-lightbox]',
]
glighboxVideoBtnsSelectors.forEach(selector => {
	GLightbox({
		selector,
		autoplayVideos: true
	})
})
